import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const ForgeGlobalSettingsExtensionPoint: LoadableType<{
	id: string;
}> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-GlobalSettings" */ './GlobalSettings.tsx'))
			.GlobalSettings,
});
